/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
import { get, kebabCase } from 'lodash';
function getTranslationPropertyKey(property) {
    return `validation.property.${kebabCase(property.substring(property.lastIndexOf('.')))}`;
}
function convert(error, uiSchema, validationType, t, params, translationPropertyKey) {
    if (uiSchema != null && t != null) {
        const { ['ui:validation']: validation } = uiSchema;
        if (validation && validation[validationType]) {
            const { [validationType]: key } = validation;
            return Object.assign(Object.assign({}, error), { message: t(key, { error: Object.assign(Object.assign({}, params), { property: `$t(${translationPropertyKey})` }) }) });
        }
    }
    return null;
}
export const translateError = (uiSchema, t) => (error) => {
    const { params, name: validationType, property } = error;
    const pattern = '\\[.*\\]';
    const reguarExp = new RegExp(`${pattern}/g`);
    const path = property.replace(reguarExp, '.items');
    const translationPropertyKey = getTranslationPropertyKey(property);
    const propertyUiSchema = get(uiSchema, path.substring(1));
    const propertyError = convert(error, propertyUiSchema, validationType, t, params, translationPropertyKey);
    if (propertyError)
        return propertyError;
    const defaultError = convert(error, uiSchema, validationType, t, params, translationPropertyKey);
    if (defaultError)
        return defaultError;
    return error;
};
//# sourceMappingURL=validationTranslator.js.map